<template>
  <div>
    <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'userList' }">Users</el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('table.history')}}</el-breadcrumb-item>    </el-breadcrumb>

    <h2 class="page-title">Users {{$t('table.history')}}</h2>

    <div v-loading="loading">
      <el-table :data="list" empty-text="There is no history yet" style="width: 100%" border>
        <el-table-column prop="modified" label="Updated at" width="180">
          <template slot-scope="scope">{{ scope.row.modified | formatDatetime }}</template>
        </el-table-column>

        <el-table-column label="Updated by" prop="modifiedBy.email"></el-table-column>

        <el-table-column prop="email" label="Email"></el-table-column>

        <el-table-column prop="roles" label="Roles">
          <template slot-scope="scope">
            <div v-for="role in scope.row.roles" :key="role">{{ roleLabel(role) }}</div>
          </template>
        </el-table-column>

        <el-table-column prop="created" label="Created at" width="180">
          <template slot-scope="scope">{{ scope.row.created | formatDatetime }}</template>
        </el-table-column>

        <el-table-column label="Created by" prop="createdBy.email"></el-table-column>
      </el-table>

      <el-button
        v-if="!last"
        @click="fetch()"
        type="infor"
        class="mt-3 w-100"
        icon="el-icon-fa-plus"
      >Load more...</el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Roles from "@/auth/roles";

export default {
  name: "app-user-history-full",

  computed: {
    ...mapGetters({
      loading: "user/historyFull/loading",
      list: "user/historyFull/list",
      last: "user/historyFull/last"
    })
  },

  created() {
    this.$store.dispatch("user/historyFull/setup");
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("user/historyFull/clear");
    next();
  },

  methods: {
    ...mapActions({
      fetch: "user/historyFull/fetch"
    }),

    roleLabel(roleId) {
      return Roles.labelOf(roleId);
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/user/user-history/user-history-full/user-history-full.vue?f84492f0